/* eslint-disable */

import React from "react";
import { Outlet } from "react-router-dom";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";
import { URL_RAINDROP } from "../../../services/constants.js";
import { toPng } from "html-to-image";

import { Size } from "../../../logic/enums.ts";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import FlexRow from "../../../ui-components/flex-row/flex-row.tsx";

const ShareElement = ({ shareComponent }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full w-full  ">
      <RaindropMotionFadeUp className="overflow-scroll">
        <div id="capture">{shareComponent}</div>
      </RaindropMotionFadeUp>
    </div>
  );
};

const ShareSheetButton = ({ title, onClick = () => {} }) => {
  const [hasBeenClicked, setHasBeenClicked] = React.useState(false);

  let icon = "fas fa-xmark";

  if (title === "More") {
    icon = "fas fa-ellipsis-h";
  }

  if (title === "Save Image") {
    icon = "fas fa-download";
  }

  if (title === "Messages") {
    icon = "fas fa-comment-dots";
  }

  if (title === "WhatsApp") {
    icon = "fab fa-whatsapp";
  }

  if (title === "Messenger") {
    icon = "fab fa-facebook-messenger";
  }

  if (title === "Facebook") {
    icon = "fab fa-facebook-f";
  }

  if (title === "Copy Link") {
    icon = "fas fa-link";
  }

  if (title === "Copy Image") {
    icon = "fas fa-copy";
  }

  const internalOnClick = () => {
    setHasBeenClicked(true);
    onClick();
    setTimeout(() => {
      setHasBeenClicked(false);
    }, 1000);
  };

  return (
    <div
      className="flex flex-col items-center w-20 gap-2 hover:scale-95 transition-all active:scale-90  cursor-pointer justify-center"
      onClick={internalOnClick}
    >
      {hasBeenClicked && <div>Clicked</div>}
      {!hasBeenClicked && (
        <>
          <div className="flex flex-col items-center justify-center h-12 w-12 dark:bg-color-dark-background-tertiary bg-color-background-tertiary rounded-full">
            <i className={`${icon} text-color-dark-text-secondary text-2xl`} />
          </div>
          <h1 className="text-sm font-semibold dark:text-color-dark-text-primary text-color-text-primary">
            {title}
          </h1>
        </>
      )}
    </div>
  );
};

const ShareSheet = ({ setShareComponent = (x) => {} }) => {
  const onMore = () => {
    const shareURL = `${URL_RAINDROP}/raindrop`;

    if (navigator.share) {
      navigator
        .share({
          title: "Check out this image!",
          text: "Here’s an image from my app.",
          url: shareURL,
        })
        .then(() => {
          console.log("RD-2212 -- Image shared successfully!");
        })
        .catch((error) => {
          console.error("RD-21123 -- Error sharing the image:", error);
        });
    } else {
      console.log("RD-77786 -- Web Share API is not supported.");
    }
  };

  const onSaveImage = () => {
    const node = document.getElementById("capture");

    if (!node) {
      console.error("Element with id 'capture' not found");
      return;
    }

    const date = new Date();
    const filename = `${date.toISOString().split("T")[0]}_raindrop.png`;

    toPng(node, { cacheBust: true })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = filename;
        link.click();
      })
      .catch((error) => {
        console.error("(RD-0093) -- Error generating PNG:", error);
      });
  };

  const onCopyLink = () => {
    const shareURL = `${URL_RAINDROP}/raindrop`;

    navigator.clipboard
      .writeText(shareURL)
      .then(() => {
        console.log("RD-2212 -- Link copied to clipboard!");
      })
      .catch((error) => {
        console.error("RD-2212 -- Error copying link:", error);
      });
  };

  const onCopyImage = () => {
    const node = document.getElementById("capture");

    if (!node) {
      console.error("Element with id 'capture' not found");
      return;
    }

    const date = new Date();
    const filename = `${date.toISOString().split("T")[0]}__bombshell.png`;

    toPng(node, { cacheBust: true })
      .then(async (dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = filename;

        const response = await fetch(dataUrl);
        const blob = await response.blob();
        const item = new ClipboardItem({ "image/png": blob });
        await navigator.clipboard.write([item]);
        // setIsCopied(true);
      })
      .catch((error) => {
        console.error("(RD-0093) -- Error generating PNG:", error);
      });
  };

  return (
    <RaindropMotionFadeUp>
      <RaindropCard additionalClasses="rounded-b-none pb-20 rounded-md">
        <FlexRow>
          <RaindropButton
            icon="fa-xmark"
            isHidingTitle={true}
            size={Size.Large}
            onClick={() => {
              setShareComponent(null);
            }}
            style={ButtonStyle.Icon}
          />
        </FlexRow>

        <FlexRow className="gap-6 justify-center">
          <ShareSheetButton title={"Copy Link"} onClick={onCopyLink} />
          <ShareSheetButton title={"Copy Image"} onClick={onCopyImage} />
          <ShareSheetButton title={"Save Image"} onClick={onSaveImage} />
          <ShareSheetButton title={"More"} onClick={onMore} />
        </FlexRow>
      </RaindropCard>
    </RaindropMotionFadeUp>
  );
};

const ShareCover = ({ setShareComponent = (x) => {}, shareComponent }) => {
  return (
    <div className="flex w-full h-full items-center justify-center absolute">
      <div className="flex flex-col w-full h-full z-20 max-w-lg">
        <ShareElement shareComponent={shareComponent} />
        <ShareSheet setShareComponent={setShareComponent} />
      </div>
    </div>
  );
};

const RaindropBaseShare = ({
  shareComponent = null,
  setShareComponent = (x) => {},
}) => {
  let appClass = "opacity-100 blur-none";

  if (shareComponent) {
    appClass = "opacity-10 blur-sm";
  }

  return (
    <div className="flex flex-col h-full w-full relative  ">
      {shareComponent && (
        <ShareCover
          setShareComponent={setShareComponent}
          shareComponent={shareComponent}
        />
      )}
      <div className={`h-full transition-all ${appClass}`}>
        <Outlet />
      </div>
    </div>
  );
};

export default RaindropBaseShare;
